"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiSelect = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
var _lodash = require("lodash");
var _Icon = require("../../Icon");
var _MultiSelectDropdown = _interopRequireDefault(require("../../MultiSelectDropdown"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const MultiSelect = exports.MultiSelect = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  var _get, _get2;
  const {
    label,
    errors,
    name,
    subTitle,
    isRequired,
    formGroupClassName,
    infoText
  } = props;
  let errorClass = errors && (0, _lodash.get)(errors, name) ? "is-invalid" : "is-valid";
  let updatedFormGroupClass = formGroupClassName ? "".concat(formGroupClassName, " ").concat(errorClass) : "".concat(errorClass);
  return /*#__PURE__*/_react.default.createElement(_reactstrap.FormGroup, {
    className: updatedFormGroupClass
  }, label && /*#__PURE__*/_react.default.createElement(_reactstrap.Label, {
    className: "form__label"
  }, label, isRequired && /*#__PURE__*/_react.default.createElement("span", {
    className: "asterisk"
  }, "*")), subTitle && /*#__PURE__*/_react.default.createElement("p", {
    className: "form__label--subtitle"
  }, subTitle), infoText && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: ["fas", "info"],
    size: "1x",
    title: infoText,
    className: "form__label--infotext"
  }), /*#__PURE__*/_react.default.createElement(_MultiSelectDropdown.default, (0, _extends2.default)({}, props, {
    ref: ref
  })), errors && ((_get = (0, _lodash.get)(errors, name)) === null || _get === void 0 ? void 0 : _get.message) && /*#__PURE__*/_react.default.createElement("p", {
    className: "form--control__error"
  }, errors && ((_get2 = (0, _lodash.get)(errors, name)) === null || _get2 === void 0 ? void 0 : _get2.message)));
});
MultiSelect.propTypes = {
  label: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  isRequired: _propTypes.default.bool,
  subTitle: _propTypes.default.string
};